module.exports = __webpack_public_path__ + "img/open-feedback@2x.19d025fa.png";